import { CircularProgress, Typography } from "@mui/material";
import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppButton from "component/button/AppButton";
import SecondaryAuthLayout from "component/secondaryAuthLayout/SecondaryAuthLayout";
import styles from "./ResetCode.module.css";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import { useResendCode } from "api/mutations/auth";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { verifiyCodeSchema } from "schemas/auth/AuthSchemas";
import TTFSnackbar from "component/AppSnackbars/TTFSnackbar";

function ResetCode() {
  const { state } = useLocation();
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(verifiyCodeSchema),
  });
  const navigate = useNavigate();
  const { resend, loading, message2, duration2, openToast2, setOpenToast2, severity2 } = useResendCode();
 


  const onSubmit = (data) => {
    navigate("/create-new-password", {
      state: {
        ...state,
        code: data.otp,
      },
    });
  };

  const handleResendCode = () => {

    if(state){
      resend({
        email: state?.email,
      });
    }else {
      navigate('/forget-password')
    }
   
  };

  return (
    <SecondaryAuthLayout>
      <div className={styles.reset_code}>
        <div className={styles.heading}>
          <Typography variant="h1">Input Reset Code</Typography>
          <Typography>
            A 5-Digit verification code was sent to the email provided, input
            code to verify your account.
          </Typography>
        </div>
        <div className={styles.form}>
          <div className={styles.otp_inputs}>
            <input
              type="number"
              name="otp"
              placeholder="Input OTP"
              {...register("otp")}
            />
            <ValidationMessage message={errors?.otp?.message} />
          </div>

          <div className={styles.resend}>
            <Typography>
              Didnt receive any code ?{" "}
              <Link
                to="/"
                onClick={(e) => {
                  e.preventDefault();
                  handleResendCode();
                }}
              >
                Resend
              </Link>
            </Typography>
            {loading && (
              <div className={styles.circular_progress}>
                <CircularProgress />
              </div>
            )}
          </div>
          <div className={styles.form_btn}>
            <AppButton
              fullwidth
              textColor="#FFFFFF"
              btnBg="#0089FF"
              btnText="Submit"
              handleAction={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
      <TTFSnackbar
        severity={severity2 }
        message={message2}
        open={openToast2}
        setOpen={setOpenToast2}
        duration={duration2}
      />
    </SecondaryAuthLayout>
  );
}

export default ResetCode;
